import Request from 'core/api/Request';

export const fetcher = async (url) => {
  const response = await Request.get(url);
  return response.body;
};

export const post = async (url, data = {}) =>
  await Request.post(url).send(data);
